import React, { useState } from 'react';
import Button from '@mui/material/Button';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
function Selfies() {
    const [selectedPhoto, setSelectedPhoto] = useState(null);

    const handlePhotoSelect = (event) => {
        const file = event.target.files[0];
        setSelectedPhoto(file);
    };

    const handlePhotoUpload = () => {
        // Logic for handling the photo upload

        setSelectedPhoto(null)
    };

    return (
        <div style={{ marginTop: 5 }}>
            <Button variant="contained" color="primary" component="label">
                <PhotoCameraIcon /> Add Photo
                <input type="file" accept="image/*" hidden onChange={handlePhotoSelect} />
            </Button>
            {
                selectedPhoto && (
                    <div>
                        <h3>Selected Photo:</h3>
                        <div style={{ border: '1px solid black', width: '300px', height: '300px', overflow: 'hidden' }}>
                            <img
                                src={URL.createObjectURL(selectedPhoto)}
                                alt="Selected"
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            />
                        </div>
                    </div>
                )
            }
            {
                selectedPhoto && (
                    <div style={{ width: '300px', display: 'flex', justifyContent: 'end' }}>
                        <Button
                            sx={{ mt: 3, mr: 2 }}
                            variant="contained"
                            color="error" onClick={handlePhotoUpload}>
                            <DeleteIcon />

                        </Button>
                        <Button
                            sx={{ mt: 3, }}
                            variant="contained"
                            color="primary" >
                            <CloudUploadIcon />

                        </Button>
                    </div>
                )
            }
        </div >
    );
}

export default Selfies;
